var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"please-review-school-campaign-component text-centered"},[(_vm.justSubmittedRemoteness)?[_vm._v(" Thank you! ")]:_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":"/my-account#!myAccountTab:teaching/"}},[_vm._v("Please review")]),_vm._v("\n\tyour grade and school to make sure it's up to date.\n")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }